import styles from '../../page.module.scss';
import star from '../../assets/decos/star.svg';
import PrimaryButton from '../buttons/PrimaryButton';
import Link from 'next/link';

export default function LibreriaSection() {
  return (
    <section id="tienda" className={styles.liberiaMainContainer}>
      <div className={styles.libreriaContainer}>
        <div className={styles.libreriaTitle}>
          <img className={styles.star} src={star.src} alt="imagen decorativa" />
          <h2 className={styles.title}>VISITÁ NUESTRA LIBRERIA</h2>
        </div>
        <p className={`${styles.text} ${styles.libreriaText}`}>
          Libros nuevos y usados, editoriales independientes, poesía, narrativa, ensayo. Estamos en
          Chacabuco 917, San Telmo, Ciudad de Buenos Aires. <br />
          Abrimos todos los días.
        </p>
        <img
          className={styles.libreriaImage}
          src={
            'https://res.cloudinary.com/dsw6fpqoz/image/upload/v1757935028/lalibre-editora/lalibrepagina_lbbx3w.png'
          }
          alt="imagen de la sección distribuidora"
        />
        <Link className={styles.libreriaLink} target="_blank" href={'https://www.lalibre.com.ar/'}>
          <PrimaryButton primary={false} text="Ver sitio de la librería" />
        </Link>
      </div>
    </section>
  );
}
